import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import DeleteModal from '../../../shared/Common/deleteModal';
import DisableNextModal from '../../../shared/Common/disableNextModal';
import CompetitorsGroupsAdd from './CompetitorsGroupsAdd/CompetitorsGroupsAdd';
import CompetitorsGroupsList from './CompetitorsGroupsList/CompetitorsGroupsList';

class CompetitorsGroups extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            createdData: false,
            editedData: false,
            deleteModalState: false,
            deletedItemId: null,
            adddedData: false,
        };
    }
    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        this.props.getCompetitorsGroups(body);
    }
    componentWillReceiveProps(nextProps){
        if(this.props.competitiveAnalysis.addCompetitorsGroupsData !== nextProps.competitiveAnalysis.addCompetitorsGroupsData){
            let body = {
                projectId: this.props.projectId,
                type: 'competitors'
            }
            this.props.getCompetitorsGroups(body);

        }
        if(nextProps.competitiveAnalysis.competitorsGroupsData !== this.props.competitiveAnalysis.competitorsGroupsData ){
            if( _.isEmpty(nextProps.competitiveAnalysis.competitorsGroupsData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }
            if( !_.isEmpty(nextProps.competitiveAnalysis.competitorsGroupsData.Items) && !this.state.editedData){
                this.setState({editedData : true, createdData : false})
                this.defaultParams = nextProps.competitiveAnalysis.competitorsGroupsData.Items[0].competitors
            }
        }
    }
    deleteModalOpen = (id) => {
        this.setState({ deleteModalState: true, deletedItemId: id })
    }

    deleteModalClose = () => {
        this.setState({ deleteModalState: false, deletedItemId: null })
    }
    addCustomerGroups = (data) => {
        if(this.state.createdData) {
            let body = {
                type : 'competitors',
                projectId : this.props.projectId,
                competitors: [
                    {
                        competitorId: data.competitorId,
                        competitorName: data.competitorName,
                    },
                ]
            }
            this.props.addCompetitorsGroups(body);
        }

        if(this.state.editedData) {
            this.defaultParams.push(data);
            let body = {
                type : 'competitors',
                id : this.props.competitiveAnalysis.competitorsGroupsData.Items[0].id,
                competitors : this.defaultParams
            }
            this.props.editCompetitorsGroups(body);
        }
    }
    deleteItem = () => {
        let updatedData = [];
        for (let item of this.defaultParams){
            item.competitorId !== this.state.deletedItemId && updatedData.push(item) ;
        }
        this.defaultParams = updatedData;
        let body = {
            type : 'competitors',
            id : this.props.competitiveAnalysis.competitorsGroupsData.Items[0].id,
            competitors : updatedData
        }

        this.props.editCompetitorsGroups(body);
        this.deleteModalClose()
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {

        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>COMPETITORS</h5>
                      </div>
                    </div>
                    {!this.props.competitiveAnalysis.competitorsGroupsFetching && <div className='row'>
                        <div className='col-lg-7'>
                            <div className='card'>
                                <div className='card-header'>
                                    <h5>Identify competitors and complementers</h5>
                                    <span>List any direct and indirect current and potential competitors you can think of, as well as any current or future complementers</span>
                                </div>
                                <div className='card-body'>
                                    <CompetitorsGroupsAdd
                                        addCompetitorsGroups={this.addCustomerGroups}
                                    />
                                    {  !_.isEmpty(this.props.competitiveAnalysis.competitorsGroupsData.Items) &&
                                            <CompetitorsGroupsList
                                                competitorsGroupsData={this.props.competitiveAnalysis.competitorsGroupsData}
                                                deleteItem={this.deleteItem}
                                                deleteModalOpen={this.deleteModalOpen}
                                                groupStepState={this.props.groupStepState}
                                            />
                                        }
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='btn btn-success'  onClick={()=>{this.props.competitiveAnalysis.competitorsGroupsData.Items.length>0 && _.isEmpty(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors) ? this.props.disableNextModal :  this.props.groupStateNext() }}>Next</div>
                                    <Link to='/toolkit' className='btn empty-btn default'> Back </Link>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                {this.state.deleteModalState &&
                    <DeleteModal
                        deleteItem={this.deleteItem}
                        deleteModalState={this.state.deleteModalState}
                        deleteModalClose={this.deleteModalClose}
                    />
                }

                {this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText='You must create at least 1 Competitor Group before continuing to Step 2'
                        disableModalTitle='Competitor Groups'
                    />
                }
                {this.props.competitiveAnalysis.competitorsGroupsFetching &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default (CompetitorsGroups);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CompetitorsGroups/CompetitorsGroups.jsx